import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const titles = {
  "/Dashboard": "Dashboard",
  "/decision-support": "Decision Support",
  "/Profile": "Profile",
  "/Gestion-des-utilisateurs": "Gestion des utilisateurs",

  "/Transport/Tarification": "Tarification",
  "/Transport/Voyages": "Voyages",
  "/Transport/Chauffeurs": "Chauffeurs",
  "/Transport/Vehicules": "Véhicules",

  "/Clients/ListClients": "Clients",
  "/Carburants": "Carburants",

  "/Logistique/Stock-scellés": "Stock Scellés",

  "/factures": "Factures",
  "/factures/create": "Créer Facture",

  "/Documents/Management": "Gestion Documents",
  "/Documents/Alerts": "Alertes Documents",
  "/Documents/Statistics": "Statistiques Documents",
  "/" : "Se connecter - EBN Logistics",
};

export default function PageTitleManager() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    let title = titles[path];

    // dynamic routes
    if (path.includes("/factures/view")) {
      title = "Voir Facture";
    }
    if (path.includes("/factures/edit")) {
      title = "Modifier Facture";
    }

    document.title = title
      ? `${title} - EBN Logistics`
      : "EBN Logistics";
  }, [location]);

  return null;
}